import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import useAuth from "../../../hooks/useAuth";
import { useGlobalValues } from "../../../contexts/globalValues";
import { APP_VERSION } from "../../../versions";

// Ajusta las rutas a las de tu menu-items
const QUICK_ACTIONS = [
  { to: "/ventas/checkout", icon: "icon-shopping-cart", label: "Punto de Venta", desc: "Iniciar una nueva venta", primary: true },
  { to: "/ventas/list", icon: "icon-file-text", label: "Historial", desc: "Operaciones realizadas" },
  { to: "/ventas/caja", icon: "icon-inbox", label: "Control de Caja", desc: "Apertura y cierre" },
  { to: "/customers/customers-list", icon: "icon-users", label: "Clientes", desc: "Directorio y saldos" },
];

const getGreeting = (hour) => {
  if (hour < 12) return "Buenos días";
  if (hour < 19) return "Buenas tardes";
  return "Buenas noches";
};

const useNow = () => {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000 * 30);
    return () => clearInterval(id);
  }, []);
  return now;
};

const useOnline = () => {
  const [online, setOnline] = useState(() => navigator.onLine);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);
  return online;
};

const HomeWelcome = () => {
  const { user } = useAuth();
  const { selectedSucursal } = useGlobalValues();
  const now = useNow();
  const online = useOnline();

  const globalValues = JSON.parse(localStorage.getItem("globalValues") || "null");
  const tienda = globalValues?.sucursales?.[0]?.nombre;
  const firstName = user?.name?.split(" ")[0] || "";

  const time = now.toLocaleTimeString("es", { hour: "2-digit", minute: "2-digit", hour12: true, });
  const date = now.toLocaleDateString("es", { weekday: "long", day: "numeric", month: "long" });

  return (
    <section className="kh-home" aria-labelledby="kh-title">
      <div className="kh-hero">
        <img src="/KyanColorFull.png" alt="" className="kh-hero__mark" />

        <div className="kh-hero__content">
          <p className="kh-eyebrow">Panel principal</p>
          <h1 id="kh-title" className="kh-title">
            {getGreeting(now.getHours())}
            {firstName ? `, ${firstName}` : ""}
          </h1>
          <div className="kh-chips">
            {tienda ? (
              <span className="kh-chip">
                <i className="feather icon-shopping-bag" aria-hidden="true" /> {tienda}
              </span>
            ) : null}
            {selectedSucursal?.sucursal ? (
              <span className="kh-chip">
                <i className="feather icon-map-pin" aria-hidden="true" /> {selectedSucursal.sucursal}
              </span>
            ) : null}
            {user?.role ? (
              <span className="kh-chip">
                <i className="feather icon-shield" aria-hidden="true" /> {user.role}
              </span>
            ) : null}
          </div>
        </div>

        <div className="kh-hero__clock">
          <p className="kh-time">{time}</p>
          <p className="kh-date">{date}</p>
        </div>
      </div>

      <div>
        <h2 className="kh-section-title">Accesos rápidos</h2>
        <div className="kh-grid">
          {QUICK_ACTIONS.map((a) => (
            <Link key={a.to} to={a.to} className={`kh-card${a.primary ? " kh-card--primary" : ""}`}>
              <span className="kh-card__icon">
                <i className={`feather ${a.icon}`} aria-hidden="true" />
              </span>
              <span className="kh-card__row">
                <span>
                  <p className="kh-card__label">{a.label}</p>
                  <p className="kh-card__desc">{a.desc}</p>
                </span>
                <i className="feather icon-arrow-right kh-card__arrow" aria-hidden="true" />
              </span>
            </Link>
          ))}
        </div>
      </div>

      <footer className="kh-footer">
        <span className={`kh-status${online ? "" : " kh-status--off"}`}>
          {online ? "En línea" : "Sin conexión · modo offline"}
        </span>
        <span>Kyan POS {APP_VERSION}</span>
      </footer>
    </section>
  );
};

export default HomeWelcome;
